import { removeDialCode as t } from "./remove-dial-code.mjs";
const n = ({
  phone: r,
  dialCode: o,
  prefix: $ = "+",
  charAfterDialCode: m = " "
}) => `${$}${o}${m}${t({
  phone: r,
  dialCode: o,
  charAfterDialCode: m,
  prefix: $
})}`;
export {
  n as addDialCode
};
